import { WORK_BADGE_REVIEW_POLICY_FULL_PATH } from "../../Documents/paths";
import { type WorkBadgeReviewPolicySource } from "../components/Policy/types";

interface GetWorkBadgeReviewPolicyUrlParams {
  source: WorkBadgeReviewPolicySource;
  shiftId: string;
  qualificationName: string;
}

export function getWorkBadgeReviewPolicyUrl(params: GetWorkBadgeReviewPolicyUrlParams): string {
  const { source, shiftId, qualificationName } = params;

  const searchParams = new URLSearchParams({
    source,
    shiftId,
    qualificationName,
  });

  return `${WORK_BADGE_REVIEW_POLICY_FULL_PATH}?${searchParams.toString()}`;
}
